import useGetUser from '@/features/User/hooks/useGetUser';
import { trpc } from '@/lib/trpc';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

const useReserveWish = (public_uid: string) => {
	const { t } = useTranslation();
	const utils = trpc.useUtils();
	const { user } = useGetUser();

	const { mutate, isPending } = trpc.wish.reserve.useMutation({
		onMutate: async ({ id_wish }) => {
			await utils.wish.get.cancel();

			const previousWishes = utils.wish.getPublic.getData({
				public_uid,
			}) || {
				status: 200,
				wishes: [],
			};

			const targetWish = previousWishes.wishes.find(
				(wish) => wish.id === id_wish
			);

			const successToast = toast.success(
				!targetWish?.fk_user_reserved
					? t('wish.reserve.success')
					: t('wish.reserve.cancel')
			);

			const optimisticWishes = previousWishes.wishes.map((wish) => {
				if (wish.id === id_wish) {
					return {
						...wish,
						fk_user_reserved: wish.fk_user_reserved
							? null
							: user?.id || null,
					};
				}
				return wish;
			});

			utils.wish.getPublic.setData(
				{ public_uid },
				{
					status: 200,
					wishes: optimisticWishes,
				}
			);

			return { previousWishes, successToast };
		},
		onError: (_, __, context) => {
			if (!context?.previousWishes) return;
			utils.wish.getPublic.setData(
				{ public_uid },
				{ status: 200, wishes: context?.previousWishes.wishes }
			);
			toast.dismiss(context.successToast);
			toast.error(t('error.generic'));
		},
	});

	return {
		reserveWish: mutate,
		reserveLoading: isPending,
	};
};

export default useReserveWish;
